import { render, staticRenderFns } from "./LinkCorporate.vue?vue&type=template&id=33324c5f"
import script from "./LinkCorporate.vue?vue&type=script&lang=js"
export * from "./LinkCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports